export enum PortInState {
    INITIAL,
    SCHEDULED,
    IN_PROGRESS,
    COMPLETED,
}

export interface IPortInInformation {
    direction: string;
    mnpId: number;
    otherNetworkAccountNumber: string;
    otherNetworkId: number;
    otherNetworkName: string;
    phoneNumber: string;
    portStartDateTime: string;
    rejectCode: string;
    serviceId: number;
    state: string;
    status: string;
    type: string;
}
